import { Controller } from "stimulus"

// Applies CSS line-clamp to the element only on mobile viewports.
//
// Tailwind's `tw-line-clamp-*` utilities don't reliably render in this project
// (preflight is disabled and the line-clamp utilities aren't always picked up),
// so this controller sets the `-webkit-line-clamp` styles directly via JS and
// listens to a matchMedia query so it stays in sync with viewport changes.
//
// Usage:
//   p data-controller="mobile-line-clamp" data-mobile-line-clamp-lines-value="3"
//
// On mobile (width < 640px), the element gets clamped to N lines; on sm+ the
// inline styles are cleared so the full text shows.
export default class extends Controller {
  static get values() {
    return { lines: Number, mobileMaxWidth: Number }
  }

  connect() {
    const max = this.hasMobileMaxWidthValue ? this.mobileMaxWidthValue : 639
    this._mediaQuery = window.matchMedia(`(max-width: ${max}px)`)
    this._handler = () => this._apply()
    this._mediaQuery.addEventListener("change", this._handler)
    this._apply()
  }

  disconnect() {
    if (this._mediaQuery && this._handler) {
      this._mediaQuery.removeEventListener("change", this._handler)
    }
  }

  _apply() {
    const lines = this.hasLinesValue ? this.linesValue : 3
    if (this._mediaQuery.matches) {
      this.element.style.display = "-webkit-box"
      this.element.style.webkitLineClamp = String(lines)
      this.element.style.webkitBoxOrient = "vertical"
      this.element.style.overflow = "hidden"
    } else {
      this.element.style.display = ""
      this.element.style.webkitLineClamp = ""
      this.element.style.webkitBoxOrient = ""
      this.element.style.overflow = ""
    }
  }
}
